
<template>
  <div class="grid flex justify-content-center mt-2">
    <div class="lg:col-6 md:col-6 sm:col-12">
      <div class="w-full">
        <div class="grid">
          <div class="col-12">
            <Card class="scalein animation-duration-200">
              <template #title>
                Step {{StepNumber}} (Create Your Account)
              </template>
              <template #content>

                <div class="formgrid grid p-3">
                  <div class="field col-12">
                    <label for="firstname6">First name</label>
                    <input id="firstname6" v-model="state.FirstName" @blur="v$.FirstName.$validate()" type="text" class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    <span v-if="v$.FirstName.$error" class="p-error"> {{ v$.FirstName.$errors[0].$message }} </span>
                  </div>
                  <div class="field col-12">
                    <label for="lastname6">Last name</label>
                    <input id="lastname6" @blur="v$.LastName.$validate()" v-model="state.LastName" type="text" class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    <span v-if="v$.LastName.$error" class="p-error"> {{ v$.LastName.$errors[0].$message }} </span>
                  </div>
                  <div class="field col-12 mt-2">
                    <label for="EmailAddress">Email</label>
                    <input id="EmailAddress" v-model="state.Email" @blur="v$.Email.$validate()" type="text" class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    <span v-if="v$.Email.$error" class="p-error"> {{ v$.Email.$errors[0].$message }} </span>
                  </div>

                  <div class="field col-12 mt-2">
                    <label for="Password">Password</label>
                    <br />
                    <Password id="Password" :toggleMask="true" @blur="v$.Password.$validate()" v-model="state.Password" inputClass="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                      <template #header>
                        <h6>Create your password</h6>
                      </template>

                      <template #footer>
                        <Divider />
                        <p class="mt-2">Suggestions</p>
                        <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                          <li>At least one lowercase</li>
                          <li>At least one uppercase</li>
                          <li>At least one numeric</li>
                          <li>Minimum 8 characters</li>
                        </ul>
                      </template>
                    </Password>

                    <span v-if="v$.Password.$error" class="p-error"> {{ v$.Password.$errors[0].$message }} </span>
                  </div>

                </div>
              </template>
              <template #footer>
                <div class="flex justify-content-end">
                  <Button icon="pi pi-arrow-left" iconPos="left" label="Back" class="bg-bluegray-700 mt-0 btn-block" style="margin-left: .5em" @click="Home" />
                  <Button icon="pi pi-check" iconPos="right" :label="BtnText" class="bg-orange-600 mt-0 btn-block" style="margin-left: .5em" @click="NextStep" :disabled="v$.$invalid" :loading="IsCreating" />
                </div>
              </template>
            </Card>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>


<style>
    .p-inputwrapper {
        width: 100% !important;
    }
</style>

<script>

  /* eslint-disable vue/no-unused-components */
  /* eslint-disable no-debugger, no-unused-vars*/
    //import Splitter from 'primevue/splitter';
    //import SplitterPanel from 'primevue/splitterpanel';
    import Password from 'primevue/password';
    import Divider from 'primevue/divider';
    import Card from 'primevue/card';
    import Button from 'primevue/button';
    import Tag from 'primevue/tag';
    import { reactive, computed } from 'vue'

    import useVuelidate from '@vuelidate/core'
    import { required, email, helpers } from '@vuelidate/validators'


   
    export default {
    name: 'StepOne',
    emits: ['set-nav'],
        components: {
            Tag,
            Password,
            Card,
            Button,
            Divider
        },
        data: () => ({
            checkbox: true,
            overlay: true,
            ProductId: null,
            IsCreating: false,
            BtnText: 'Next',
          User: {
                FirstName: '',
                LastName: '',
                Email: '',
                Password: ''
            },
          StepNumber: 1
        }),
      mounted() {
            setTimeout(() => {
                this.overlay = false
            }, 2000)
      },
      setup() {
         
            const isStrongPassword = helpers.regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/)

            const state = reactive({
                FirstName: '',
                LastName: '',
                Email: '',
                Password: ''
            })
            const rules = computed(() => {
                return {
                    Email: { required: helpers.withMessage("Email Is Required To Start", required), email: helpers.withMessage("Input Must Be A Valid Email Address", email) },
                    FirstName: { required: helpers.withMessage("Please Enter Your First Name", required)},
                    LastName: { required: helpers.withMessage("Please Enter Your Last Name", required)},
                    Password: { required: helpers.withMessage("You Must Specify A Password", required), isStrongPassword: helpers.withMessage("Password Must Meet The Strong Specifications", isStrongPassword)},
                }
            });

            const v$ = useVuelidate(rules, state)
            return { state, v$}
        },

    methods: {
      Home() {

        this.$router.push('/')
      },
      GetTagInfo() {
        var getProduct = this.ProductDescriptions.filter(c => c.Id == this.ProductId)[0]
        return getProduct;
      },
            showError() {
                this.$toast.add({ severity: 'error', summary: 'Error!', detail: 'There was an error creating your account' });
            },
         async  NextStep() {
         
           var self = this;
             self.BtnText = 'Creating Account';
             self.IsCreating = true;

             await this.$http.post('/Authorization/Register',
              {
                       
                        FirstName: this.state.FirstName,
                        LastName: this.state.LastName,
                        Email: this.state.Email,
                        UserName: this.state.Email,
                        Password: this.state.Password,
                        RoleId: 'SUBS',
               }).then(function (response) {
                     self.IsCreating = false;
                 if (response.data.success) { 

                   self.$toast.add({ severity: 'success', summary: 'Registration Complete!' });

                   setTimeout( () => {
                     var stateData = {
                       token: response.data.tokenization.token,
                       userName: self.userName,
                       isAuthenticated: true,
                       role: response.data.role,
                       organizationId: response.data.organizationId,
                       id: response.data.id
                     };

                     self.$store.commit('SetAuth', stateData);
                     var homePage = self.$store.getters.user.homepage;
                     self.$router.push({ path: homePage })
                   }, 1500)

                    
                      }
                      else {
                            self.IsCreating = false;
                            self.BtnText = 'Sign Up'
                            self.showError();
                        }
                    })
            },
        }
    }
</script>